import PropTypes from 'prop-types';
import { LinkShape } from './components/Slide/Slide.shapes';

export const SliderItemShape = PropTypes.shape({
  imageUrl: PropTypes.string.isRequired,
  link: LinkShape,
});
